export default __webpack_public_path__ + "static/media/welcome-blue.0045c422.svg";